import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import {Helmet} from 'react-helmet';
import './ugiWaterSewerPage.scss';

/**
 * The UgiWaterSewerPage component.
 *
 * @constructor
 */
export class UgiWaterSewerPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="ugi-water-sewer-page" className="system-page">
        <Helmet>
          <title>Water and Sewer Utilities - NEI</title>
          <meta name = "description" content ="Water mains are used to deliver water to a customer’s service pipe. A sewer main is the principal pipe in a sewage collection system." />
        </Helmet>
        <div className="container-fluid">
          <div className="row row-odd">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p>Water mains are common, running down most city streets, and are used to deliver water to a customer’s service pipe. A sewer main is the principal pipe in a sewage collection system. It is part of a larger sewer system that carries off liquid and solid sewage. What isn’t as easy to see is that there are 1.2 million miles of underground water mains – that’s 26 miles of water mains for every mile of interstate highway! According to the Environmental Protection Agency, there is an equally large network of sewer systems that transports liquid and solid waste to treatment facilities.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-even">
            <div className="container">
              <div className="row h-100">
                <div className="col my-auto">
                  <h1>Resource Links</h1>
                  <p><a href="https://awwa.org" target="_blank">awwa.org</a></p>
                  <p><a href="https://www.apwa.net" target="_blank">apwa.net</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UgiWaterSewerPage.propTypes = {};

export default UgiWaterSewerPage;



// WEBPACK FOOTER //
// ./src/components/pages/ugiWaterSewer/UgiWaterSewerPage.js